import {
  ActionIcon,
  Button,
  Card,
  Group,
  ScrollArea,
  Table,
  Text,
  TextInput,
} from '@mantine/core';
import { IoMdSearch } from 'react-icons/io';
import useSWR from 'swr';
import { useState } from 'react';
import { FaCalendarAlt } from 'react-icons/fa';
import {
  type Employee,
  type Employees,
} from '@/schemas/API/GET/employee/response';
import { getFetcher } from '@/api/fetchers';

export const EmployeeModal = ({
  closeModal,
  startIds,
}: {
  closeModal: (newEmployees: number[] | null) => void;
  startIds: number[];
}): JSX.Element => {
  const [chosenEmployees, setChosenEmployees] = useState<Employee[]>([]);
  const [searchValue, setSearchValue] = useState('');
  const [query, setQuery] = useState<string>('');

  const handleChange = (employee: Employee) => {
    if (!chosenEmployees.includes(employee)) {
      setChosenEmployees([...chosenEmployees, employee]);
    } else {
      setChosenEmployees(
        chosenEmployees.filter(
          chosenEmployee => chosenEmployee.id !== employee.id
        )
      );
    }
  };

  const { data: employees } = useSWR<Employees>(
    `employees?query=${query}`,
    getFetcher
  );

  const employeeRows = chosenEmployees
    .concat(
      employees
        ? employees.content.filter(
            employee =>
              !startIds.includes(employee.id) &&
              !chosenEmployees.some(emp => emp.id === employee.id)
          )
        : []
    )
    .map(element => (
      <Table.Tr key={element.id}>
        <Table.Td>
          <ActionIcon variant="transparent" color="darkblue" size="lg">
            <FaCalendarAlt />
          </ActionIcon>
        </Table.Td>
        <Table.Td>{element.firstName + ' ' + element.lastName}</Table.Td>
        <Table.Td align="right">
          <Button
            variant={
              chosenEmployees.some(emp => emp.id === element.id)
                ? 'filled'
                : 'outline'
            }
            radius="md"
            onClick={() => {
              handleChange(element);
            }}
          >
            {chosenEmployees.some(emp => emp.id === element.id)
              ? 'Odebrat'
              : 'Vybrat'}
          </Button>
        </Table.Td>
      </Table.Tr>
    ));

  return (
    <Card>
      <Text fw={700} size="lg">
        Vybrat nežádoucí zaměstnance
      </Text>
      <TextInput
        size="md"
        mt="sm"
        mb="sm"
        placeholder="hledat"
        value={searchValue}
        onChange={event => setSearchValue(event.currentTarget.value)}
        onKeyDown={event => {
          if (event.key === 'Enter') setQuery(searchValue);
        }}
        leftSection={
          <ActionIcon
            variant="transparent"
            color="gray"
            onClick={() => setQuery(searchValue)}
          >
            <IoMdSearch />
          </ActionIcon>
        }
      />
      <ScrollArea h={500}>
        <Table>
          <Table.Tbody>{employeeRows}</Table.Tbody>
        </Table>
      </ScrollArea>
      <Group justify="space-between" mt="lg">
        <Button
          variant="outline"
          radius="md"
          pl="xl"
          pr="xl"
          onClick={() => closeModal(null)}
        >
          Zrušit
        </Button>
        <Button
          variant="filled"
          radius="md"
          pl="xl"
          pr="xl"
          onClick={() =>
            closeModal([...startIds, ...chosenEmployees.map(emp => emp.id)])
          }
        >
          Potvrdit
        </Button>
      </Group>
    </Card>
  );
};
